<template>
  <v-dialog
    v-model="newUserDialog"
    max-width="1200px"
    persistent
    v-if="getDetailCash != null"
  >
    <v-card style="border-radius: 10px">
      <v-toolbar
        dark
        style="background-color: #fddf00; color: black"
        class="elevation-0"
      >
        <v-toolbar-title><h4>Detail</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false)" color="black" size="30"
          >close</v-icon
        >
      </v-toolbar>
      <v-layout row wrap style="padding: 35px" justify-center>
        <v-flex xs12 sm4>
          <div style="text-align: center"><h2>weserve</h2></div>
          <div style="display: flex; justify-content: center">
            <img src="@/assets/bank-svg.svg" />
          </div>
          <div style="padding: 5px">
            <div class="text">Bank name</div>
            <div style="display: flex">
              <img
                :src="getDetailCash.bank_weserve.bank_weserve_bank.bank_icon"
                style="width:30px; height: 27px;"
              />
              <h3 style="padding: 2px">
                {{ getDetailCash.bank_weserve.bank_weserve_bank.bank_name_en }}
              </h3>
            </div>
          </div>
          <div style="padding: 5px">
            <div class="text">Bank number</div>
            <h3>
              {{ getDetailCash.bank_weserve.bank_weserve_account_number }}
            </h3>
          </div>
          <div style="padding: 5px">
            <div class="text">Account name</div>
            <h3>{{ getDetailCash.bank_weserve.bank_weserve_account_name }}</h3>
          </div>
        </v-flex>
        <v-flex xs12 sm4>
          <div
            style="display: flex; justify-content: center; margin-top: 30px;"
          >
            <img
              src="@/assets/Group 5918.svg"
              v-if="$vuetify.breakpoint.xs"
              style="height: 30px;transform: rotate(0.25turn);"
            />
            <img src="@/assets/Group 5918.svg" v-else />
          </div>
        </v-flex>
        <v-flex
          xs12
          sm4
          :style="{
            marginTop: this.$vuetify.breakpoint.xs ? '50px' : null,
          }"
        >
          <div style="text-align: center"><h2>weserve</h2></div>
          <div style="display: flex; justify-content: center">
            <img src="@/assets/XMLID_830.svg" />
          </div>
          <div style="padding: 5px">
            <div class="text">Bank name</div>
            <div style="display: flex">
              <img
                :src="getDetailCash.bank_manager.bank_manager_bank.bank_icon"
                style="width:30px; height: 27px;"
              />
              <h3 style="padding: 2px">
                {{ getDetailCash.bank_manager.bank_manager_bank.bank_name_en }}
              </h3>
            </div>
          </div>
          <div style="padding: 5px">
            <div class="text">Bank number</div>
            <h3>
              {{ getDetailCash.bank_manager.bank_manager_bank_number }}
            </h3>
          </div>
          <div style="padding: 5px">
            <div class="text">Account name</div>
            <h3>{{ getDetailCash.bank_manager.bank_manager_customer_name }}</h3>
          </div>
        </v-flex>
      </v-layout>
      <v-divider class="mx-4"></v-divider>
      <v-layout justify="space-between" style="padding:35px">
        <v-flex xs12 sm6>
          <div style="display: flex; justify-content: start">
            <div>
              <h3>Withdraw</h3>
              <h3 style="color: red">Commission</h3>
              <h3 style="color: green">Total</h3>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div style="display: flex; justify-content: end">
            <div>
              <h3>{{ `${getDetailCash.withdraw_price} THB` }}</h3>
              <h3 style="color: red">
                {{ `${getDetailCash.commission_price} THB` }}
              </h3>
              <h3 style="color: green">
                {{ `${getDetailCash.total_price} THB` }}
              </h3>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-divider class="mx-4"></v-divider>
      <div style="display: flex; justify-content: center">
        <v-btn
          flat
          large
          color="error"
          @click.stop="(dialog = true), (textReject = true)"
          >REJECT</v-btn
        >
        <v-btn
          flat
          large
          color="success"
          @click.stop="(dialog = true), (textApprove = true)"
          >APPROVE</v-btn
        >
      </div>
    </v-card>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" max-width="500">
        <v-card style="border-radius: 10px">
          <v-card-title class="px-4"
            ><h2>
              {{
                textReject
                  ? "Do you want to Reject this bank?"
                  : textApprove
                  ? "Do you want to Approve this bank"
                  : null
              }}
            </h2>
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout row wrap style="padding: 15px">
              <v-flex xs12 sm20>
                <v-text-field
                  :rules="[(v) => !!v || 'Required']"
                  v-if="textReject"
                  v-model="textRemark"
                  placeholder="Remark"
                  outline
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <v-card-actions class="pr-5 py-4">
            <v-spacer></v-spacer>
            <v-btn
              flat
              dark
              color="red"
              style="
                    width: 120px;
                    border-radius: 7px;
                    font-weight: bold;
                    font-size: 16px;
                  "
              @click="
                (dialog = false),
                  (textReject = false),
                  (textApprove = false),
                  (textDelete = false),
                  (textRemark = null)
              "
              :loading="btnLoading"
              >cancel</v-btn
            >
            <v-btn
              flat
              dark
              color="black"
              style="
                    width: 120px;
                    background-color: #fddf00;
                    border-radius: 7px;
                    font-weight: bold;
                    font-size: 16px;
                  "
              @click="
                {
                  {
                    textReject
                      ? rejectbank(idProps)
                      : textApprove
                      ? approveBank(idProps)
                      : null;
                  }
                }
              "
              :loading="btnLoading"
              >confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import _ from "lodash";

let _this = this;
export default {
  props: ["newUserDialog", "button", "idProps", "select"],
  data() {
    return {
      dialog: false,
      preview: "",
      valid: true,
      btnLoading: false,
      textReject: false,
      textApprove: false,
      textDelete: false,
      textRemark: "",
    };
  },
  computed: {
    ...mapState({
      getDetailCash: (state) => state.cashRequest.getDetailCash,
      getcashDetail: (state) => state.cashRequest.cashListData,
    }),
  },
  methods: {
    ...mapActions({
      getDetailCash: "cashRequest/getDetailCash",
      getDetailCashData: "cashRequest/fetchcashList",
    }),

    async approveBank(item) {
      let result = await this.$store.dispatch(
        "cashRequest/ApproveBankManager",
        item
      );
      if (result == false) return;
      await this.getDetailCashData(this.select);
      await this.$store.dispatch("cashRequest/fetchCountRequest");
      this.dialog = false;
      this.isAdding = true;
      let _this = this;
      this.$emit("onSaved", {
        done() {
          _this.isAdding = false;
        },
      });
    },
    async rejectbank(item) {
      if (this.$refs.form.validate(item)) {
        const payload = {
          transaction_partner_id: item,
          remark: this.textRemark,
        };
        this.btnLoading = true;
        let result = await this.$store.dispatch(
          "cashRequest/RejectBankManager",
          {
            payload,
          }
        );
        if (result == false) return;
        await this.$store.dispatch("cashRequest/fetchCountRequest");
        let index = this.getcashDetail.findIndex(
          (val) => val.transaction_partner_id == item
        );
        this.getcashDetail.splice(index, 1);
        this.dialog = false;
        this.isAdding = true;
        let _this = this;
        this.$emit("onSaved", {
          done() {
            _this.isAdding = false;
          },
        });
      }
    },
  },
};
</script>

<style>
.line-newpass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-newpass:after {
  content: "Set Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>
